import wx from 'weixin-js-sdk'
import api from '@/utils/apics'
import config from '@/utils/config'
import {Indicator} from "mint-ui";
import {
  loadJssdk
} from '@/utils/tool'

function wxShare(params, webUrl, img, title, desc, linkUrl) {
  // console.log("aaa", img, title);
  return new Promise((resolve, reject) => {
    Indicator.open({
      text: "加载中..."
    });
    let url = '';
    let n = 0;
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const element = params[key];
        if (n == 0) {
          url += '?'
        } else {
          url += '&'
        }
        n++;
        url += key + '=' + element
      }
    }
    let lineLink = linkUrl ? `${config.webUrl}${linkUrl}${url}` : webUrl;
    let imgUrl = img;
    let shareTitle = title;
    let descContent = desc ? desc : title;
    api.gzhJsApiSign({
      url: webUrl
    }).then(res => {
      console.log(res)
      wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp + '',
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: ['showAllNonBaseMenuItem', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone']
      });
      wx.checkJsApi({
        jsApiList: ['showAllNonBaseMenuItem', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'],
        success: function(res) {
          console.log("res", res)
        }
      })
      wx.ready(function () {
        setTimeout(function () {
          console.log("AAA");
          wx.showAllNonBaseMenuItem();
        }, 200)
        console.log(lineLink, imgUrl, shareTitle, descContent)
        loadJssdk(lineLink, imgUrl, shareTitle, descContent).then(type => {
          resolve()
        }, err => {
          console.log('ready报错', err)
          reject()
        })
      })
      Indicator.close();
    }, err => {
      Indicator.close();
    })
  })
}

// 隐藏基础按钮
function hideMenuItem() {
  return new Promise((resolve, reject) => {
    api.gzhJsApiSign({
      url: webUrl
    }).then(res => {
      wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp + '',
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: ['hideAllNonBaseMenuItem']
      });
      wx.error(function (err) {
        console.log('err', err)
      });

      wx.ready(function () {
        setTimeout(function () {
          wx.hideAllNonBaseMenuItem();
        }, 200)
      })
    }, err => {})
  })
}

export default {
  wxShare: wxShare,
  hideMenuItem: hideMenuItem
}



// WEBPACK FOOTER //
// ./src/utils/wxShare.js